import { Box, Divider } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IColoredTagGroup, IKeyFigureGroup, ITags } from "src/api/server/extended-search";
import { TagsList } from "src/components/pages/search/components/tags-filter/components/tags-list";
import { ISearch } from "src/components/pages/search/search.types";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { EnumTagColor } from "src/types/common-enum";
import { KeyFiguresGroup } from "../../key-figures-filter/components/key-figures-group";
import { LeverageProductsSelection } from "./leverage-products-selection";

interface IPopularFiltersContent extends ISearch {
    popularKeyFiguresGroup: IKeyFigureGroup;
    tagsData: ITags;
}

export const PopularFiltersContent = ({ popularKeyFiguresGroup, tagsData, onSearch }: IPopularFiltersContent) => {
    const { t } = useTranslation("extended-search");
    const { basics, tradings, rewards, investmentHorizon, investmentRegion, alphaBeta } = tagsData;
    const orderedTagGroups: IColoredTagGroup[] = [
        {
            tags: rewards.tags,
            color: EnumTagColor.Green,
        },
        {
            tags: tradings.tags,
            color: EnumTagColor.Lilac,
        },
        {
            tags: investmentHorizon.tags,
            color: EnumTagColor.Blue,
        },
        {
            tags: investmentRegion.tags,
            color: EnumTagColor.Orange,
        },
        {
            tags: basics.tags,
            color: EnumTagColor.Gray,
        },
        {
            tags: alphaBeta.tags,
            color: EnumTagColor.Teal,
        },
    ];

    return (
        <>
            <KeyFiguresGroup keyFiguresGroup={popularKeyFiguresGroup} onSearch={onSearch} mb={3} />
            <Divider sx={{ mb: 3, borderColor: "gray.100" }} />
            <WfHeading component="h2" fontSize={{ xs: "sm", sm: "md" }}>
                {t("filter-title.popular-wikifolio-tags")}
            </WfHeading>
            <Box mt={2} mb={3}>
                <TagsList tags={tagsData} onSearch={onSearch} orderedTagGroups={orderedTagGroups} />
            </Box>
            <Divider sx={{ mb: 3, borderColor: "gray.100" }} />
            <WfHeading component="h2" fontSize={{ xs: "sm", sm: "md" }}>
                {t("filter-title.leverage-products")}
            </WfHeading>
            <Box mt={2} mb={{ xs: 0, sm: 4 }}>
                <LeverageProductsSelection onSearch={onSearch} />
            </Box>
        </>
    );
};
